import { useMemo } from "react";
import {
  Breadcrumb,
  DownloadExcel,
  ErrorAlert,
  PageHero,
  SearchToggle,
  ShoppingCartIcon,
  TableRowsPerPage,
  useFetchData,
  useSearch,
  useState,
} from "@";
import { DataTable } from "@/shared/components/tanstackTable";

import { getCarts } from "./utils/api";
import ShowCart from "./components/ShowCart";
import MultiSearch from "./components/MultiSearch";
import { excelHeaderCellsName, searchValues } from "./utils/options";
import { TableActions, tableColumns } from "./components/TableOptions";

const Index = () => {
  const [cart, setCart] = useState([]);
  const [loadingCart, setLoadingCart] = useState(false);
  const links = [{ name: "السلات المتروكة", link: "" }];

  // Search state and update function
  const { search, updateSearch } = useSearch(searchValues);

  // Fetch data hook
  const { data, isLoading, error, pg, fetchData, updatePg } = useFetchData({
    fun: getCarts,
    params: [search.values],
  });

  // Append actions column to base columns
  const columns = useMemo(
    () => [
      ...tableColumns,
      {
        id: "actions",
        header: "خيارات",
        size: 100,
        cell: ({ row }) => (
          <TableActions
            id={row.original.id}
            setCart={setCart}
            setLoadingCart={setLoadingCart}
          />
        ),
      },
    ],
    [],
  );

  return (
    <>
      <ErrorAlert reload={fetchData} show={error} />
      <Breadcrumb links={links} />

      <ShowCart loading={loadingCart} data={cart} />

      <main className="table-card relative">
        <PageHero
          eyebrow="التبرعات / السلات"
          title="السلات المتروكة"
          count={pg.rows}
          icon={ShoppingCartIcon}
          hideCount={isLoading}
          headerClassName="flex-row items-center justify-between"
        >
          <TableRowsPerPage
            pagination={pg}
            onRowsPerPageChange={(size) => updatePg({ size })}
          />
          <DownloadExcel
            headerCellsName={excelHeaderCellsName}
            fetch={getCarts}
            search={search.values}
            length={data?.length}
          />
          <SearchToggle toggle={() => updateSearch({ show: !search.show })} />
        </PageHero>

        <MultiSearch
          search={search}
          onSubmit={fetchData}
          dataLength={data?.length}
          updateSearch={updateSearch}
        />

        <DataTable
          data={data}
          columns={columns}
          isLoading={isLoading}
          pagination={pg}
          onPageChange={(page) => updatePg({ page })}
          onPageSizeChange={(size) => updatePg({ size, page: 1 })}
        />
      </main>
    </>
  );
};

export default Index;
